import axios from 'axios';
import { getPublicSiteOrigin } from './constants/site';

/** API del sitio público — mismo host canónico en prod */
export function getPublicApiUrl(): string {
  if (typeof window !== 'undefined') {
    return `${getPublicSiteOrigin()}/api`;
  }
  const env = process.env.REACT_APP_API_URL?.replace(/\/$/, '');
  if (env && env.includes('eugenial.com.ar')) {
    return env.endsWith('/api') ? env : `${env}/api`;
  }
  return 'http://localhost:5010/api';
}

export function getTwitchRedirectUri(): string {
  return `${getPublicSiteOrigin()}/auth/twitch/callback`;
}

export function getTwitchAuthorizeUrl(): string {
  const clientId = process.env.REACT_APP_TWITCH_CLIENT_ID;
  if (!clientId) {
    throw new Error('Falta REACT_APP_TWITCH_CLIENT_ID en .env');
  }
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: getTwitchRedirectUri(),
    response_type: 'code',
    scope: 'user:read:email user:read:follows',
  });
  return `https://id.twitch.tv/oauth2/authorize?${params.toString()}`;
}

export function getDiscordRedirectUri(): string {
  return `${getPublicSiteOrigin()}/auth/discord/callback`;
}

export function getDiscordAuthorizeUrl(): string {
  const clientId =
    process.env.REACT_APP_DISCORD_CLIENT_ID ||
    process.env.REACT_APP_DISCORD_OAUTH_CLIENT_ID;
  if (!clientId) {
    throw new Error('Falta REACT_APP_DISCORD_CLIENT_ID en el build del sitio (web).');
  }
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: getDiscordRedirectUri(),
    response_type: 'code',
    scope: 'identify',
  });
  return `https://discord.com/api/oauth2/authorize?${params.toString()}`;
}

const api = axios.create({
  baseURL: getPublicApiUrl(),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('eugenial_twitch_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
